@if(item.navCap){
<div mat-subheader class="nav-caption">
  {{ item.navCap | translate }}
</div>
} @if(!item.navCap && !item.external && !item.twoLines) {
<a
  mat-list-item
  (click)="onItemSelected(item)"
  [ngClass]="{
    'mat-toolbar mat-primary activeMenu': item.route ? router.isActive(item.route, true) : false,
    expanded: expanded,
    disabled: item.disabled
  }"
  class="menu-list-item"
>
  <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <span
    class="hide-menu"
    style="white-space: normal; word-break: break-word; line-height: 1.5; width: 155px; max-width: 100%"
    >{{ dir() === "rtl" ? item.displayName : item.displayNameEn }}</span
  >
  @if(item.children && item.children.length) {
  <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'"> expand_more </mat-icon>
  </span>
  } @if(item.chip) {
  <span>
    <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{ item.chipContent }}</span>
  </span>
  }
</a>
}

<!-- external Link -->

@if(!item.navCap && item.external) {
<mat-list-item onClick="window.open('//google.com')" class="menu-list-item" target="_blank">
  <i-tabler class="routeIcon" name="{{ item.iconName }}" matListItemIcon></i-tabler>
  <span
    class="hide-menu"
    style="white-space: normal; word-break: break-word; line-height: 1.5; width: 150px; max-width: 100%"
    >{{ item.displayName | translate }}</span
  >
</mat-list-item>
}

<!-- children -->
@if(expanded) { @for(child of item.children; track child) {
<div [ngStyle]="dir() === 'rtl' ? { 'padding-right': '20px' } : { 'padding-left': '20px' }">
  <app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth + 1"> </app-nav-item>
</div>
} }
